import get from "lodash/get";

export function deleteFromCache(id, store, key, queryOptions) {
  try {
    const data = store.readQuery(queryOptions);
    const idx = data[key].findIndex(a => a.id === id);
    get(data, key).splice(idx, 1);
    store.writeQuery({
      ...queryOptions,
      data
    });
  } catch (e) {
    // TODO: I don't think we actually need to do anything here
  }
}

export function addToCache(object, store, key, queryOptions) {
  try {
    const data = store.readQuery(queryOptions);
    get(data, key).push(object);
    store.writeQuery({
      ...queryOptions,
      data
    });
  } catch (e) {
    // TODO: Well, do we actually need to do anything here?
  }
}



// WEBPACK FOOTER //
// ./src/utils/queryHelpers.js